import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';
import { Lock, AlertCircle } from 'lucide-react';

const AdminLogin = () => {
    const { admin, login, loading } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [err, setErr] = useState('');
    const [sending, setSending] = useState(false);

    if (loading) return <div className="container-page pt-32 text-white/50">Loading…</div>;
    if (admin) return <Navigate to="/admin/dashboard" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setErr('');
        setSending(true);
        try {
            await login(email, password);
        } catch (e2) {
            const detail = e2.response?.data?.detail;
            setErr(typeof detail === 'string' ? detail : 'Invalid credentials');
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-6 py-24" data-testid="admin-login-page">
            <div className="w-full max-w-md">
                <div className="mb-10 flex justify-center">
                    <Logo size="lg" />
                </div>
                <form onSubmit={submit} className="border border-white/10 bg-brand-surface p-8 md:p-10 space-y-5" data-testid="admin-login-form">
                    <div className="label-caps text-brand-primary flex items-center gap-2">
                        <Lock className="h-4 w-4" /> Admin sign in
                    </div>
                    <h1 className="font-display font-black uppercase tracking-tighter text-3xl text-white">
                        Dry Ice Bulls Cleaning System® CMS
                    </h1>

                    <div>
                        <label className="label-caps text-white/60 block mb-2">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full bg-brand-bg border border-white/10 focus:border-brand-primary transition-colors text-white p-4 outline-none"
                            data-testid="admin-login-email"
                        />
                    </div>
                    <div>
                        <label className="label-caps text-white/60 block mb-2">Password</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full bg-brand-bg border border-white/10 focus:border-brand-primary transition-colors text-white p-4 outline-none"
                            data-testid="admin-login-password"
                        />
                    </div>

                    {err && (
                        <div className="flex items-start gap-2 text-red-200 border border-red-500/40 bg-red-500/10 p-3 text-sm" data-testid="admin-login-error">
                            <AlertCircle className="h-4 w-4 flex-shrink-0 mt-0.5" />
                            <span>{err}</span>
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={sending}
                        className="w-full bg-brand-primary hover:bg-brand-primaryHover disabled:opacity-60 text-brand-ink font-bold px-6 py-4 label-caps transition-colors"
                        data-testid="admin-login-submit"
                    >
                        {sending ? 'Signing in…' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
